import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mx-auto px-8 py-6 sm:py-7 md:py-8 lg:py-10" }
const _hoisted_2 = { class: "w-full py-12 text-slate-900" }

import type { Group } from "@/types/domain";
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import GroupsList from "@/components/companionGroups/GroupsList.vue";
import GroupDetail from "@/components/companionGroups/GroupDetail.vue";
import CreateGroupModal from "@/components/companionGroups/CreateGroupModal.vue";
import ProposeSessionModal from "@/components/companionGroups/ProposeSessionModal.vue";
import SharePopup from "@/components/companionGroups/SharePopup.vue";
import LeaveConfirmDialog from "@/components/companionGroups/LeaveConfirmDialog.vue";
import GuestJoinPopup from "@/components/companionGroups/GuestJoinPopup.vue";
import JoinSuccessPopup from "@/components/companionGroups/JoinSuccessPopup.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'companionGroups',
  props: {
    isLoggedIn: { type: Boolean },
    initialDiseaseKey: {},
    initialGroupSlug: {},
    backUrl: {}
  },
  emits: ["group-created", "group-joined", "group-left"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const lg = useLiveGroups(props, emit);
const { router } = lg;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          name: "view-slide",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(lg).currentView.value === 'groups')
              ? (_openBlock(), _createBlock(GroupsList, {
                  key: "groups",
                  groups: _unref(lg).groups.value,
                  "member-group-ids": _unref(lg).memberGroupIds.value,
                  "joining-group-id": _unref(lg).joiningGroupId.value,
                  "join-group-error": _unref(lg).joinGroupError.value,
                  "search-query": _unref(lg).searchQuery.value,
                  "show-disease-dropdown": _unref(lg).showDiseaseDropdown.value,
                  "selected-disease": _unref(lg).selectedDisease.value,
                  "filtered-diseases": _unref(lg).filteredDiseases.value,
                  "filtered-groups": _unref(lg).filteredGroups.value,
                  onViewGroup: _unref(lg).viewGroup,
                  onCreateGroup: _unref(lg).handleCreateGroup,
                  onJoinGroup: _unref(lg).handleJoinGroup,
                  onLeaveGroup: _unref(lg).handleLeaveGroup,
                  "onUpdate:searchQuery": _cache[0] || (_cache[0] = 
            (v) => {
              _unref(lg).searchQuery.value = v;
              _unref(lg).filterDiseases();
            }
          ),
                  "onUpdate:showDiseaseDropdown": _cache[1] || (_cache[1] = 
            (v) => {
              _unref(lg).showDiseaseDropdown.value = v;
            }
          ),
                  onSelectDisease: _unref(lg).selectDisease,
                  onClearDisease: _unref(lg).clearDisease,
                  onSearchBlur: _unref(lg).onSearchBlur
                }, null, 8, ["groups", "member-group-ids", "joining-group-id", "join-group-error", "search-query", "show-disease-dropdown", "selected-disease", "filtered-diseases", "filtered-groups", "onViewGroup", "onCreateGroup", "onJoinGroup", "onLeaveGroup", "onSelectDisease", "onClearDisease", "onSearchBlur"]))
              : (_unref(lg).activeDetailGroup.value)
                ? (_openBlock(), _createBlock(GroupDetail, {
                    key: "detail",
                    group: _unref(lg).activeDetailGroup.value,
                    sessions: _unref(lg).sessions.value,
                    "loading-sessions": _unref(lg).loadingSessions.value,
                    "expanded-session-id": _unref(lg).expandedSessionId.value,
                    "member-group-ids": _unref(lg).memberGroupIds.value,
                    "is-logged-in": props.isLoggedIn,
                    "session-link-copied": _unref(lg).sessionLinkCopied.value,
                    "detail-link-copied": _unref(lg).detailLinkCopied.value,
                    onBack: _cache[2] || (_cache[2] = ($event: any) => (
            props.backUrl
              ? _unref(router).push(props.backUrl)
              : (_unref(lg).currentView.value = 'groups')
          )),
                    onProposeSession: _unref(lg).handleProposeSession,
                    onToggleSession: _unref(lg).toggleSessionAttendance,
                    onExpandSession: _cache[3] || (_cache[3] = 
            (id) => {
              _unref(lg).expandedSessionId.value =
                _unref(lg).expandedSessionId.value === id ? null : id;
            }
          ),
                    onShareSession: _cache[4] || (_cache[4] = (session) => _unref(lg).openSharePopup('session', session)),
                    onShareDetail: _cache[5] || (_cache[5] = () => _unref(lg).openSharePopup('group')),
                    onWhatsappDetail: _unref(lg).shareDetailGroupWhatsApp,
                    onTelegramDetail: _unref(lg).shareDetailGroupTelegram,
                    onCopyDetail: _unref(lg).copyDetailGroupLink
                  }, null, 8, ["group", "sessions", "loading-sessions", "expanded-session-id", "member-group-ids", "is-logged-in", "session-link-copied", "detail-link-copied", "onProposeSession", "onToggleSession", "onWhatsappDetail", "onTelegramDetail", "onCopyDetail"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    (_unref(lg).modalMode.value === 'create')
      ? (_openBlock(), _createBlock(CreateGroupModal, {
          key: 0,
          "is-open": _unref(lg).showModal.value,
          "current-step": _unref(lg).currentStep.value,
          "is-submitting": _unref(lg).isSubmitting.value,
          "submit-error": _unref(lg).submitError.value,
          "is-private": _unref(lg).isPrivate.value,
          "modal-disease-search": _unref(lg).modalDiseaseSearch.value,
          "modal-selected-disease": _unref(lg).modalSelectedDisease.value,
          "filtered-modal-diseases": _unref(lg).filteredModalDiseases.value,
          "group-name": _unref(lg).groupName.value,
          "group-description": _unref(lg).groupDescription.value,
          "success-title": _unref(lg).successTitle.value,
          "success-message": _unref(lg).successMessage.value,
          "success-mode": _unref(lg).successMode.value,
          "created-group": _unref(lg).createdGroup.value,
          "created-group-slug": _unref(lg).createdGroupSlug.value,
          "group-created-copied": _unref(lg).groupCreatedCopied.value,
          "link-copied": _unref(lg).linkCopied.value,
          onClose: _unref(lg).closeModal,
          onChooseType: _unref(lg).chooseGroupType,
          onFilterModalDiseases: _cache[6] || (_cache[6] = 
      (v) => {
        _unref(lg).modalDiseaseSearch.value = v;
        _unref(lg).filterModalDiseases();
      }
    ),
          onSelectModalDisease: _cache[7] || (_cache[7] = 
      (d) => {
        _unref(lg).modalSelectedDisease.value = d;
      }
    ),
          "onUpdate:groupName": _cache[8] || (_cache[8] = 
      (v) => {
        _unref(lg).groupName.value = v;
      }
    ),
          "onUpdate:groupDescription": _cache[9] || (_cache[9] = 
      (v) => {
        _unref(lg).groupDescription.value = v;
      }
    ),
          "onUpdate:modalDiseaseSearch": _cache[10] || (_cache[10] = 
      (v) => {
        _unref(lg).modalDiseaseSearch.value = v;
      }
    ),
          "onUpdate:currentStep": _cache[11] || (_cache[11] = 
      (v) => {
        _unref(lg).currentStep.value = v;
      }
    ),
          onSubmit: _unref(lg).handleSubmitCreate,
          onGoToGroup: _unref(lg).goToCreatedGroup,
          onShareWhatsapp: _unref(lg).shareNewGroupWhatsApp,
          onShareTelegram: _unref(lg).shareNewGroupTelegram,
          onCopyInvite: _unref(lg).copyNewGroupInvite
        }, null, 8, ["is-open", "current-step", "is-submitting", "submit-error", "is-private", "modal-disease-search", "modal-selected-disease", "filtered-modal-diseases", "group-name", "group-description", "success-title", "success-message", "success-mode", "created-group", "created-group-slug", "group-created-copied", "link-copied", "onClose", "onChooseType", "onSubmit", "onGoToGroup", "onShareWhatsapp", "onShareTelegram", "onCopyInvite"]))
      : _createCommentVNode("", true),
    (_unref(lg).modalMode.value === 'propose-session')
      ? (_openBlock(), _createBlock(ProposeSessionModal, {
          key: 1,
          "is-open": _unref(lg).showModal.value,
          "current-step": _unref(lg).currentStep.value,
          "group-name": _unref(lg).activeDetailGroup.value?.name ?? '',
          "proposal-date": _unref(lg).proposalDate.value,
          "proposal-days": _unref(lg).proposalDays.value,
          "available-time-slots": _unref(lg).availableTimeSlots.value,
          "proposal-time": _unref(lg).proposalTime.value,
          "proposal-description": _unref(lg).proposalDescription.value,
          "proposal-max-attendees": _unref(lg).proposalMaxAttendees.value,
          "is-submitting": _unref(lg).isSubmitting.value,
          "submit-error": _unref(lg).submitError.value,
          "success-title": _unref(lg).successTitle.value,
          "success-message": _unref(lg).successMessage.value,
          "success-mode": _unref(lg).successMode.value,
          "session-info-copied": _unref(lg).sessionInfoCopied.value,
          onClose: _unref(lg).closeModal,
          onSelectDay: _unref(lg).selectProposalDay,
          "onUpdate:proposalTime": _cache[12] || (_cache[12] = 
      (v) => {
        _unref(lg).proposalTime.value = v;
      }
    ),
          "onUpdate:proposalDescription": _cache[13] || (_cache[13] = 
      (v) => {
        _unref(lg).proposalDescription.value = v;
      }
    ),
          "onUpdate:proposalMaxAttendees": _cache[14] || (_cache[14] = 
      (v) => {
        _unref(lg).proposalMaxAttendees.value = v ?? '';
      }
    ),
          onSubmit: _unref(lg).handleSubmitSession,
          onShareWhatsapp: _unref(lg).shareSessionWhatsApp,
          onShareTelegram: _unref(lg).shareSessionTelegram,
          onCopyInfo: _unref(lg).copySessionInfo
        }, null, 8, ["is-open", "current-step", "group-name", "proposal-date", "proposal-days", "available-time-slots", "proposal-time", "proposal-description", "proposal-max-attendees", "is-submitting", "submit-error", "success-title", "success-message", "success-mode", "session-info-copied", "onClose", "onSelectDay", "onSubmit", "onShareWhatsapp", "onShareTelegram", "onCopyInfo"]))
      : _createCommentVNode("", true),
    _createVNode(SharePopup, {
      "is-open": _unref(lg).sharePopupOpen.value,
      url: _unref(lg).sharePopupUrl.value,
      "whatsapp-url": _unref(lg).sharePopupWhatsAppUrl.value,
      "telegram-url": _unref(lg).sharePopupTelegramUrl.value,
      copied: _unref(lg).sharePopupCopied.value,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_unref(lg).sharePopupOpen.value = false)),
      onCopy: _unref(lg).sharePopupCopy
    }, null, 8, ["is-open", "url", "whatsapp-url", "telegram-url", "copied", "onCopy"]),
    _createVNode(JoinSuccessPopup, {
      "is-open": _unref(lg).joinSuccessPopupOpen.value,
      onClose: _unref(lg).closeJoinSuccess,
      onShare: _unref(lg).handleJoinSuccessShare
    }, null, 8, ["is-open", "onClose", "onShare"]),
    _createVNode(LeaveConfirmDialog, {
      "is-open": _unref(lg).showLeaveConfirm.value,
      group: _unref(lg).groupToLeave.value,
      "is-leaving-group": _unref(lg).isLeavingGroup.value,
      onConfirm: _unref(lg).confirmLeaveGroup,
      onCancel: _cache[16] || (_cache[16] = ($event: any) => (_unref(lg).showLeaveConfirm.value = false))
    }, null, 8, ["is-open", "group", "is-leaving-group", "onConfirm"]),
    _createVNode(GuestJoinPopup, {
      "is-open": 
      !!_unref(lg).guestJoinPopupSession.value || !!_unref(lg).guestJoinPopupGroup.value
    ,
      "guest-join-state": _unref(lg).guestJoinState.value,
      "guest-join-email": _unref(lg).guestJoinEmail.value,
      "guest-join-loading": _unref(lg).guestJoinLoading.value,
      "guest-join-error": _unref(lg).guestJoinError.value,
      onClose: _unref(lg).closeGuestJoinPopup,
      onLogin: _unref(lg).guestJoinChooseLogin,
      onRegister: _unref(lg).guestJoinChooseRegister,
      "onUpdate:guestJoinEmail": _cache[17] || (_cache[17] = 
      (v) => {
        _unref(lg).guestJoinEmail.value = v;
      }
    ),
      "onUpdate:guestJoinState": _cache[18] || (_cache[18] = 
      (v) => {
        _unref(lg).guestJoinState.value = v;
      }
    ),
      onSubmitEmail: _unref(lg).guestJoinSubmitEmail
    }, null, 8, ["is-open", "guest-join-state", "guest-join-email", "guest-join-loading", "guest-join-error", "onClose", "onLogin", "onRegister", "onSubmitEmail"])
  ], 64))
}
}

})